import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// CRA dev: localhost and 127.0.0.1 do NOT share localStorage — causes "Invalid token" if you switch URLs.
// Canonicalise to localhost on port 3000 only (one-time redirect).
if (typeof window !== "undefined") {
  const { hostname, port, protocol, pathname, search, hash } = window.location;
  if (hostname === "127.0.0.1" && port === "3000") {
    window.location.replace(`${protocol}//localhost:3000${pathname}${search}${hash}`);
  }
}

// Service workers + webpack dev server are flaky; only register in production.
if (process.env.NODE_ENV === "development" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
} else if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
